export const ru = {
  "tests.result.answer_protocol_title": "Протокол ответов",
  "tests.result.answer_protocol_number": "№",
  "tests.result.answer_protocol_question": "Вопрос",
  "tests.result.answer_protocol_answer": "Ответ",
  "tests.result.answer_protocol_scales": "Шкалы",
  "tests.result.analysis.title": "Анализ шкал",
  "tests.result.combination_interpretations": "Комбинации",
  "tests.result.profile_contradictions": "Противоречия профиля",
  "tests.result.scale_name": "Шкала",
  "tests.result.score": "Балл",
  "tests.result.raw_score": "Сырой балл",
  "tests.result.result_value": "Результат",
  "tests.result.deviation": "Отклонение",
  "tests.result.analysis.zone_column": "Зона",
  "tests.result.summary_title": "Сводка",
  "tests.luscher_quick.result_title": "Результаты цветового теста Люшера",
  "tests.luscher_full.result_title": "Результаты полного теста Люшера",
  "tests.luscher_quick.phase1_title": "Первая выборка",
  "tests.luscher_quick.phase2_title": "Вторая выборка",
  "tests.luscher_quick.interpretations_toggle_more": "Подробнее",
  "tests.luscher_quick.interpretations_toggle_less": "Свернуть",
  "tests.luscher_quick.shifts_title": "Сдвиги между выборками",
  "tests.luscher_quick.shift_line": "%{color}: %{from} → %{to} (Δ %{delta})",
  "tests.mmpi_2.result_title": "Результат MMPI-2",
  "tests.index.szondi_mpv.name": "Сонди МПВ",
  "tests.index.szondi_orig.name": "Сонди",
  "hand_test.result.title": "Результат Hand Test",
  "mmpi.result.profile_chart.caption": "Профиль MMPI",
  "mmpi.result.table.caption": "Т-баллы по шкалам",
  "mmpi.result.table.scale": "Шкала",
  "mmpi.result.table.t_score": "Т-балл",
  "mmpi.result.code_type_template_placeholder": "Шаблона интерпретации для данного кодового типа пока нет.",
  "mmpi.result.cannot_say_count": "Ответов «не могу сказать»: %{count}",
  "mmpi.result.verdict.valid": "Существенных нарушений валидности не выявлено",
  "mmpi.result.verdict.caution": "Осторожность — проверьте индикаторы валидности",
  "mmpi.result.verdict.invalid": "Профиль может быть невалидным — интерпретировать с осторожностью",
  "mmpi.result.flags.cannot_say_exceeds_recommendation": "Много пропусков (затрудняюсь ответить)",
  "mmpi.result.flags.f_scale_elevated": "Шкала F выше 80T: профиль недостоверен",
  "mmpi.result.flags.l_scale_elevated": "Шкала L 70T и выше: профиль недостоверен (стремление приукрасить себя)",
  "mmpi.result.flags.f_scale_high": "Шкала F 71–80T: достоверность под сомнением (напряжённость, драматизация или небрежность)",
  "mmpi.result.flags.k_scale_elevated": "Шкала K выше 65T: неоткровенность, стремление скрыть проблемы",
  "mmpi.result.flags.f_minus_k_overreporting": "Индекс F−K выше порога: возможна аггравация симптомов",
  "mmpi.result.flags.f_minus_k_underreporting": "Индекс F−K ниже порога: возможна диссимуляция",
  "mmpi.result.flags.vrin_elevated": "Повышенная шкала VRIN (несогласованность ответов)",
  "mmpi.result.flags.trin_elevated": "Повышенная шкала TRIN (несогласованность true/false)",

  "szondi.result.raw_scores_title": "Сырые баллы",
  "szondi.result.protocol_title": "Протокол выборов",
  "szondi.result.protocol_view_selected": "Выбранные",
  "szondi.result.protocol_view_series": "Вся серия",
  "szondi.result.protocol_series": "Серия %{n}",
  "szondi.result.profile_title": "Профиль по факторам",
  "szondi.result.profile_title_mpv": "Профиль по факторам (отметки в сериях)",
  "szondi.result.profile_grid_caption": "Профильная сетка Сонди",
  "szondi.result.factor": "Фактор",
  "szondi.result.raw_front": "Передний план (F)",
  "szondi.result.raw_rear": "Задний план (B)",
  "szondi.result.raw_total": "Сумма (R)",
  "szondi.result.raw_positive": "Плюс (+)",
  "szondi.result.raw_negative": "Минус (−)",
  "szondi.result.raw_sign": "Доминирование плана (F vs B)",
  "szondi.result.marks_front": "Передний план",
  "szondi.result.marks_rear": "Задний план",
  "szondi.result.marks_combined": "Суммарный (передний + задний)",
  "szondi.result.reaction": "Тип реакции",
  "szondi.result.vectors_title": "Векторы (S, P, Sch, C)",
  "szondi.result.vectors_combined_title": "Суммарный профиль",
  "szondi.result.vectors_front_title": "Векторы — передний план",
  "szondi.result.vectors_rear_title": "Векторы — задний план",
  "szondi.result.vector_column": "Вектор",
  "szondi.result.positive_column": "+",
  "szondi.result.negative_column": "−",
  "szondi.result.loaded_column": "Нагрузка",
  "szondi.result.total": "всего",
  "szondi.result.vector_loaded": "нагружен",
  "szondi.result.vector_not_loaded": "не нагружен",
  "szondi.result.syndromes_title": "Синдромные сочетания",
  "szondi.result.profile_contrast_title": "«Я» и «Мы» (передний vs задний план)",
  "szondi.result.typology_title": "Типологический профиль (Собчик)",
  "szondi.result.registration_sheet_title": "Регистрационный бланк",
  "szondi.result.registration_series_column": "Серия",
  "szondi.result.vector_header.S": "S",
  "szondi.result.vector_header.P": "Р",
  "szondi.result.vector_header.Sch": "Sch",
  "szondi.result.vector_header.C": "C",

  "szondi.vectors.S.label": "S — сексуальный",
  "szondi.vectors.P.label": "P — пароксизмальный",
  "szondi.vectors.Sch.label": "Sch — Я-влечение",
  "szondi.vectors.C.label": "C — контактный",

  "szondi.syndromes.tension":
    "Синдром напряжения: одновременная нагрузка векторов S и Sch — телесно-энергетическое напряжение и сжатие «Я».",
  "szondi.syndromes.discharge":
    "Синдром разрядки: нагрузка векторов P и C — аффективная разрядка и контактная вовлечённость.",
  "szondi.syndromes.affect":
    "Синдром аффекта: нагрузка векторов P и S — сочетание пароксизмальности и сексуальной сферы.",
  "szondi.syndromes.contact":
    "Синдром контакта: нагрузка векторов Sch и C — напряжение между границами «Я» и потребностью в объекте.",

  "szondi.profile_contrast.congruent":
    "Передний и задний планы в целом согласованы: «Я» и «Мы» совпадают по полярности на большинстве факторов — относительная целостность профиля.",
  "szondi.profile_contrast.mirror":
    "Передний и задний планы зеркалят друг друга: на многих факторах полярности противоположны — возможное вытеснение и внутренний конфликт.",
  "szondi.profile_contrast.mixed":
    "Смешанный контраст планов: часть факторов согласована, часть противоречит — точечные зоны напряжения между «Я» и «Мы».",

  "szondi.typology.conform":
    "Конформный тип (Собчик): высокое совпадение переднего и заднего планов, умеренная выраженность полных реакций.",
  "szondi.typology.introvert":
    "Интровертированный тип: зеркальный контраст планов с преобладанием негативных полюсов — склонность к внутренней дистанции.",
  "szondi.typology.neurotic":
    "Невротический тип: много полных реакций при смешанном или зеркальном контрасте планов — высокая внутренняя актуальность тем.",
  "szondi.typology.extravert":
    "Экстравертированный тип: согласованные планы с преобладанием позитивных полюсов — открытая реализация влечений.",
  "szondi.typology.rigid":
    "Ригидный тип: несколько реакций с высоким напряжением — жёсткая фиксация на отдельных влечениях.",
  "szondi.typology.demonstrative":
    "Демонстративный тип: выраженная полная позитивная реакция по фактору hy — потребность в признании и видимости.",

  "szondi.procedure.discrete": "Дискретный",
  "szondi.procedure.continuum": "Континуум",

  "szondi.reactions.medium":
    "Средняя реакция (2–3 выбора по фактору): тема заметна, но не доминирует в протоколе.",
  "szondi.reactions.full_positive":
    "Полная позитивная реакция: фактор значим, испытуемый в целом принимает эту тенденцию у себя.",
  "szondi.reactions.full_negative":
    "Полная негативная реакция: фактор значим, выражено внутреннее несогласие с проявлением тенденции.",
  "szondi.reactions.full_ambivalent":
    "Полная амбивалентная реакция: сильное значение фактора при явном смешении «за» и «против».",
  "szondi.reactions.full_positive_high_tension":
    "Позитивная реакция с высоким напряжением: четыре выбора одного знака (или четыре доминирующих при смешении).",
  "szondi.reactions.full_negative_high_tension":
    "Негативная реакция с высоким напряжением: четыре отвержения одного знака (или четыре доминирующих при смешении).",
  "szondi.reactions.full_positive_very_high_tension":
    "Сильно усиленная позитивная реакция: пять выборов одного знака.",
  "szondi.reactions.full_negative_very_high_tension":
    "Сильно усиленная негативная реакция: пять отвержений одного знака.",
  "szondi.reactions.full_positive_max_tension":
    "Максимальная позитивная реакция: шесть выборов одного знака.",
  "szondi.reactions.full_negative_max_tension":
    "Максимальная негативная реакция: шесть отвержений одного знака.",
  "szondi.reactions.full_ambivalent_rejection_dominant":
    "Амбивалентная реакция с перевесом отвержения (маркер «i»): при избытке отвержений при небольшом числе симпатий.",
  "szondi.reactions.null": "Нулевая реакция: по фактору нет выраженного предпочтения или отвержения.",

  "unified_report.fallback.unknown_section": "Неизвестный тип секции",
  "unified_report.investigations_history.title": "Краткая сводка",
  "unified_report.investigations_history.procedure": "Процедура",
  "unified_report.investigations_history.loaded_vectors": "Нагруженные векторы",
  "unified_report.investigations_history.contrast": "Контраст планов",
  "unified_report.investigations_history.typology": "Типология",
  "unified_report.profile_chart.cabinet_hint":
    "Полный график профиля доступен в кабинете. Краткие данные:",
  "unified_report.typology.match_score": "совпадение: %{score}",
  "unified_report.empty_sections": "Секции отчёта отсутствуют.",
  "unified_report.leading.title": "Ведущий стиль",
  "unified_report.leading.share": "%{label}: %{value}%",
  "unified_report.validity.index": "Индекс вариабельности: %{value}",
  "unified_report.validity.status.reliable": "Достоверно",
  "unified_report.validity.status.doubtful": "Сомнительно",
  "unified_report.validity.status.unreliable": "Недостоверно",
  "unified_report.validity.status.below_norm_table": "Сумма ниже таблицы состава",
  "unified_report.flags.fallback": "Недостоверно",
  "unified_report.flags.unreliable": "Недостоверно",
  "unified_report.flags.doubtful": "Сомнительно",
  "unified_report.flags.below_norm_table": "Сумма ниже 15, индекс не считается",
  "unified_report.flags.norm_age_out_of_range": "Возраст вне таблицы норм, взят крайний коэффициент",
  "unified_report.flags.iq_undefined": "IQ не определён: сырой балл ниже 10",
  "unified_report.flags.iq_above_table": "IQ выше таблицы и показан как «больше N»",
  "unified_report.flags.prognoz.unreliable": "Ответы недостоверны: шкала искренности выше 10",
  "unified_report.flags.raven_spm.unreliable": "Профиль серий не похож на ожидаемый состав",
  "unified_report.flags.raven_spm.series_A_unreliable": "Серия A сильно отклоняется от ожидаемого состава",
  "unified_report.flags.raven_spm.series_B_unreliable": "Серия B сильно отклоняется от ожидаемого состава",
  "unified_report.flags.raven_spm.series_C_unreliable": "Серия C сильно отклоняется от ожидаемого состава",
  "unified_report.flags.raven_spm.series_D_unreliable": "Серия D сильно отклоняется от ожидаемого состава",
  "unified_report.flags.raven_spm.series_E_unreliable": "Серия E сильно отклоняется от ожидаемого состава",
}

export const en = {
  "tests.result.answer_protocol_title": "Answer protocol",
  "tests.result.answer_protocol_number": "#",
  "tests.result.answer_protocol_question": "Question",
  "tests.result.answer_protocol_answer": "Answer",
  "tests.result.answer_protocol_scales": "Scales",
  "tests.result.analysis.title": "Scale analysis",
  "tests.result.combination_interpretations": "Combinations",
  "tests.result.profile_contradictions": "Profile contradictions",
  "tests.result.scale_name": "Scale",
  "tests.result.score": "Score",
  "tests.result.raw_score": "Raw score",
  "tests.result.result_value": "Result",
  "tests.result.deviation": "Deviation",
  "tests.result.analysis.zone_column": "Zone",
  "tests.result.summary_title": "Summary",
  "tests.luscher_quick.result_title": "Lüscher color test results",
  "tests.luscher_full.result_title": "Full Lüscher test results",
  "tests.luscher_quick.phase1_title": "First selection",
  "tests.luscher_quick.phase2_title": "Second selection",
  "tests.luscher_quick.interpretations_toggle_more": "Show details",
  "tests.luscher_quick.interpretations_toggle_less": "Hide",
  "tests.luscher_quick.shifts_title": "Shifts between selections",
  "tests.luscher_quick.shift_line": "%{color}: %{from} → %{to} (Δ %{delta})",
  "tests.mmpi_2.result_title": "MMPI-2 result",
  "tests.index.szondi_mpv.name": "Szondi MPV",
  "tests.index.szondi_orig.name": "Szondi",
  "hand_test.result.title": "Hand Test result",
  "mmpi.result.profile_chart.caption": "MMPI profile",
  "mmpi.result.table.caption": "T-scores by scale",
  "mmpi.result.table.scale": "Scale",
  "mmpi.result.table.t_score": "T-score",
  "mmpi.result.code_type_template_placeholder":
    "No interpretation template for this code type yet.",
  "mmpi.result.cannot_say_count": "Cannot say answers: %{count}",
  "mmpi.result.verdict.valid": "No major validity flags",
  "mmpi.result.verdict.caution": "Caution — review validity indicators",
  "mmpi.result.verdict.invalid": "Profile may be invalid — interpret with caution",
  "mmpi.result.flags.cannot_say_exceeds_recommendation": "Many omitted responses (Cannot say)",
  "mmpi.result.flags.f_scale_elevated": "F scale above 80T: profile invalid",
  "mmpi.result.flags.l_scale_elevated": "L scale at 70T or higher: profile invalid (favourable self-presentation)",
  "mmpi.result.flags.f_scale_high": "F scale 71–80T: validity questionable (distress, dramatization or careless responding)",
  "mmpi.result.flags.k_scale_elevated": "K scale above 65T: defensiveness, concealment of problems",
  "mmpi.result.flags.f_minus_k_overreporting": "F−K index above threshold: possible symptom over-reporting",
  "mmpi.result.flags.f_minus_k_underreporting": "F−K index below threshold: possible under-reporting",
  "mmpi.result.flags.vrin_elevated": "Elevated VRIN (response inconsistency)",
  "mmpi.result.flags.trin_elevated": "Elevated TRIN (True/False inconsistency)",

  "szondi.result.raw_scores_title": "Raw scores",
  "szondi.result.protocol_title": "Choice protocol",
  "szondi.result.protocol_view_selected": "Selected",
  "szondi.result.protocol_view_series": "Full series",
  "szondi.result.protocol_series": "Series %{n}",
  "szondi.result.profile_title": "Factor profile",
  "szondi.result.profile_title_mpv": "Factor profile (series marks)",
  "szondi.result.profile_grid_caption": "Szondi profile grid",
  "szondi.result.factor": "Factor",
  "szondi.result.raw_front": "Foreground (F)",
  "szondi.result.raw_rear": "Background (B)",
  "szondi.result.raw_total": "Total (R)",
  "szondi.result.raw_positive": "Plus (+)",
  "szondi.result.raw_negative": "Minus (−)",
  "szondi.result.raw_sign": "Plane dominance (F vs B)",
  "szondi.result.marks_front": "Foreground",
  "szondi.result.marks_rear": "Background",
  "szondi.result.marks_combined": "Combined (foreground + background)",
  "szondi.result.reaction": "Reaction type",
  "szondi.result.vectors_title": "Vectors (S, P, Sch, C)",
  "szondi.result.vectors_combined_title": "Combined profile",
  "szondi.result.vectors_front_title": "Vectors — foreground",
  "szondi.result.vectors_rear_title": "Vectors — background",
  "szondi.result.vector_column": "Vector",
  "szondi.result.positive_column": "+",
  "szondi.result.negative_column": "−",
  "szondi.result.loaded_column": "Load",
  "szondi.result.total": "total",
  "szondi.result.vector_loaded": "loaded",
  "szondi.result.vector_not_loaded": "not loaded",
  "szondi.result.syndromes_title": "Syndrome combinations",
  "szondi.result.profile_contrast_title": "“I” and “We” (foreground vs background)",
  "szondi.result.typology_title": "Typological profile (Sobchik)",
  "szondi.result.registration_sheet_title": "Registration sheet",
  "szondi.result.registration_series_column": "Series",
  "szondi.result.vector_header.S": "S",
  "szondi.result.vector_header.P": "P",
  "szondi.result.vector_header.Sch": "Sch",
  "szondi.result.vector_header.C": "C",

  "szondi.vectors.S.label": "S — sexual",
  "szondi.vectors.P.label": "P — paroxysmal",
  "szondi.vectors.Sch.label": "Sch — ego drive",
  "szondi.vectors.C.label": "C — contact",

  "szondi.syndromes.tension":
    "Tension syndrome: simultaneous load on vectors S and Sch — bodily-energy tension and ego constriction.",
  "szondi.syndromes.discharge":
    "Discharge syndrome: load on vectors P and C — affective discharge and contact involvement.",
  "szondi.syndromes.affect":
    "Affect syndrome: load on vectors P and S — combination of paroxysmal and sexual spheres.",
  "szondi.syndromes.contact":
    "Contact syndrome: load on vectors Sch and C — tension between ego boundaries and object need.",

  "szondi.profile_contrast.congruent":
    "Foreground and background are largely congruent: “I” and “We” match in polarity on most factors.",
  "szondi.profile_contrast.mirror":
    "Foreground and background mirror each other: polarities opposed on many factors — possible repression.",
  "szondi.profile_contrast.mixed":
    "Mixed plan contrast: some factors congruent, some conflicting — focal tension zones between “I” and “We”.",

  "szondi.typology.conform":
    "Conform type (Sobchik): high foreground/background match with moderate full reactions.",
  "szondi.typology.introvert":
    "Introverted type: mirrored plan contrast with negative poles — tendency toward inner distance.",
  "szondi.typology.neurotic":
    "Neurotic type: many full reactions with mixed or mirrored contrast — high inner topicality.",
  "szondi.typology.extravert":
    "Extraverted type: congruent plans with positive poles — open expression of drives.",
  "szondi.typology.rigid":
    "Rigid type: several high-tension reactions — rigid fixation on particular drives.",
  "szondi.typology.demonstrative":
    "Demonstrative type: strong full positive hy reaction — need for recognition and visibility.",

  "szondi.procedure.discrete": "Discrete",
  "szondi.procedure.continuum": "Continuum",

  "szondi.reactions.medium":
    "Medium reaction (2–3 choices on a factor): the theme is noticeable but not dominant.",
  "szondi.reactions.full_positive":
    "Full positive reaction: the factor matters; the person largely accepts this tendency.",
  "szondi.reactions.full_negative":
    "Full negative reaction: the factor matters; clear inner disagreement with the tendency.",
  "szondi.reactions.full_ambivalent":
    "Full ambivalent reaction: strong factor meaning with clear mix of for and against.",
  "szondi.reactions.full_positive_high_tension":
    "Positive high-tension reaction: four choices of one sign (or four dominant when mixed).",
  "szondi.reactions.full_negative_high_tension":
    "Negative high-tension reaction: four rejections of one sign (or four dominant when mixed).",
  "szondi.reactions.full_positive_very_high_tension":
    "Strongly amplified positive reaction: five choices of one sign.",
  "szondi.reactions.full_negative_very_high_tension":
    "Strongly amplified negative reaction: five rejections of one sign.",
  "szondi.reactions.full_positive_max_tension":
    "Maximum positive reaction: six choices of one sign.",
  "szondi.reactions.full_negative_max_tension":
    "Maximum negative reaction: six rejections of one sign.",
  "szondi.reactions.full_ambivalent_rejection_dominant":
    "Ambivalent reaction with rejection dominance (“i” marker).",
  "szondi.reactions.null": "Null reaction: no clear preference or rejection on the factor.",

  "unified_report.fallback.unknown_section": "Unknown section type",
  "unified_report.investigations_history.title": "Brief summary",
  "unified_report.investigations_history.procedure": "Procedure",
  "unified_report.investigations_history.loaded_vectors": "Loaded vectors",
  "unified_report.investigations_history.contrast": "Plan contrast",
  "unified_report.investigations_history.typology": "Typology",
  "unified_report.profile_chart.cabinet_hint":
    "The full profile chart is available in the cabinet. Brief data:",
  "unified_report.typology.match_score": "match: %{score}",
  "unified_report.empty_sections": "Report sections are missing.",
  "unified_report.leading.title": "Leading style",
  "unified_report.leading.share": "%{label}: %{value}%",
  "unified_report.validity.index": "Variability index: %{value}",
  "unified_report.validity.status.reliable": "Reliable",
  "unified_report.validity.status.doubtful": "Doubtful",
  "unified_report.validity.status.unreliable": "Unreliable",
  "unified_report.validity.status.below_norm_table": "Total is below the composition table",
  "unified_report.flags.fallback": "Unreliable",
  "unified_report.flags.unreliable": "Unreliable",
  "unified_report.flags.doubtful": "Doubtful",
  "unified_report.flags.below_norm_table": "Total is below 15, so the index is not calculated",
  "unified_report.flags.norm_age_out_of_range": "Age is outside the norm table; the nearest coefficient is used",
  "unified_report.flags.iq_undefined": "IQ is undefined: the raw score is below 10",
  "unified_report.flags.iq_above_table": "IQ is above the table and shown as “over N”",
  "unified_report.flags.prognoz.unreliable": "Answers are unreliable: the sincerity scale is above 10",
  "unified_report.flags.raven_spm.unreliable": "The series profile does not match the expected composition",
  "unified_report.flags.raven_spm.series_A_unreliable": "Series A deviates strongly from the expected composition",
  "unified_report.flags.raven_spm.series_B_unreliable": "Series B deviates strongly from the expected composition",
  "unified_report.flags.raven_spm.series_C_unreliable": "Series C deviates strongly from the expected composition",
  "unified_report.flags.raven_spm.series_D_unreliable": "Series D deviates strongly from the expected composition",
  "unified_report.flags.raven_spm.series_E_unreliable": "Series E deviates strongly from the expected composition",
}
